<template>
   <v-dialog v-model="deleteDialog.status" width="300">
     <v-card>
       <v-card-title>Confirm Delete</v-card-title>
       <v-card-text>
         Are you sure to delete?
       </v-card-text>
       <v-divider></v-divider>
       <v-card-actions>
         <v-btn outlined small color="primary" @click="deleteItem">Confirm</v-btn>
         <v-btn outlined small color="grey" @click="deleteDialog.status = false">Cancel</v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>
</template>

<script>
export default {
  name: 'index',
  data: () => ({
    deleteDialog: {}
  }),
  created () {
    this.deleteDialog = this.$store.state.deleteDialog
  },
  methods: {
    deleteItem () {
      this.$store.commit('setLoadingState', true)
      if (this.$store.state.deleteDialog.item.essential_id !== undefined) {
        this.$apis.deleteEssential({ essential_id: this.$store.state.deleteDialog.item.essential_id }).then(res => {
          this.deleteDialog.status = false
          this.$store.commit('setSnackBar', {
            status: true,
            color: 'success',
            icon: 'far fa-check-square',
            message: 'Report deleted'
          })
          this.$store.state.viewRecord.report_items = this.$store.state.viewRecord.report_items.filter(item => item.essential_id !== this.$store.state.deleteDialog.item.essential_id)
        })
        this.$store.commit('setLoadingState', false)
      } else {
        this.$apis.readEssential().then(res => {
          let essentials = res.data.data.filter(item => item.client_id === this.$store.state.deleteDialog.item.client_id)
          essentials.forEach(e => {
            this.$apis.deleteEssential({ essential_id: e.essential_id })
          })
          this.$apis.readInternalIds().then(res => {
            let internals = res.data.data.filter(item => item.client_id === this.$store.state.deleteDialog.item.client_id)
            internals.forEach(e => {
              this.$apis.deleteInternalIds({ internal_id: e.internal_id })
            })
            this.$apis.readAdditionalInformation().then(res => {
              let AdditionalInformation = res.data.data.filter(item => item.client_id === this.$store.state.deleteDialog.item.client_id)
              AdditionalInformation.forEach(e => {
                this.$apis.deleteAdditionalInformation({ client_id: e.client_id })
              })
              this.$store.commit('setLoadingState', false)
              this.deleteDialog.status = false
              this.$store.commit('setSnackBar', {
                status: true,
                color: 'success',
                icon: 'far fa-check-square',
                message: 'User Deleted'
              })
            })
          })
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
